import { Star } from 'lucide-react';
import { cn } from '@/lib/utils';

interface TrustpilotRatingProps {
  rating: number;
  size?: 'sm' | 'md' | 'lg';
  showScore?: boolean;
  showLogo?: boolean;
}

export const TrustpilotRating = ({ 
  rating, 
  size = 'md', 
  showScore = true,
  showLogo = true 
}: TrustpilotRatingProps) => {
  const sizeClasses = {
    sm: 'h-3 w-3',
    md: 'h-4 w-4',
    lg: 'h-5 w-5'
  };

  const textSizes = {
    sm: 'text-xs',
    md: 'text-sm',
    lg: 'text-base'
  };

  return (
    <div className="flex items-center gap-2">
      {/* Stars */}
      <div className="flex items-center gap-0.5">
        {[1, 2, 3, 4, 5].map((star) => {
          const fill = Math.min(Math.max(rating - star + 1, 0), 1);
          
          return (
            <div key={star} className="relative inline-block">
              {/* Empty star background */}
              <Star className={cn(sizeClasses[size], "text-gray-300")} />
              
              {/* Filled portion - TRUSTPILOT GREEN */}
              {fill > 0 && (
                <div 
                  className="absolute top-0 left-0 overflow-hidden"
                  style={{ width: `${fill * 100}%` }}
                >
                  <Star 
                    className={cn(sizeClasses[size])} 
                    fill="#00b67a" 
                    stroke="#00b67a"
                  />
                </div>
              )}
            </div>
          );
        })}
      </div>
      
      {/* Rating Score */}
      {showScore && (
        <span className={cn("font-semibold", textSizes[size])}>
          {rating.toFixed(1)}
        </span>
      )}
      
      {/* Trustpilot Logo/Text */}
      {showLogo && (
        <span className={cn("text-muted-foreground", textSizes[size])}>
          Trustpilot
        </span>
      )}
    </div>
  );
};
